module.exports = {"meta":{"title":"E-business - Kumuluz"}}


//////////////////
// WEBPACK FOOTER
// ./static/locales/en/e-poslovanje.json
// module id = 550
// module chunks = 114276838955818